
import { supabase } from "@/integrations/supabase/client";
import logger from "@/lib/logger";

// Function to record proposal usage in the database
export const recordProposalUsage = async (jobDescriptionLength: number) => {
  try {
    // Get current authenticated user
    const { data: authData } = await supabase.auth.getUser();
    const userId = authData?.user?.id;

    if (!userId) {
      logger.warn("Cannot record proposal usage: No authenticated user found");
      return;
    }

    const { error } = await supabase
      .from('proposal_usage')
      .insert({
        job_description_length: jobDescriptionLength,
        model: 'gpt-4o',
        user_id: userId
      });
    
    if (error) {
      logger.error("Error recording proposal usage:", error);
    } else {
      logger.log("Proposal usage recorded successfully");
    }
  } catch (err) {
    logger.error("Exception recording proposal usage:", err);
  }
};
